import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-view-trade-agreement-2',
  templateUrl: './modal-view-trade-agreement2.component.html',
  styleUrls: ['./modal-view-trade-agreement2.component.scss']
})
export class ModalViewTradeAgreementComponent2 implements OnInit {

  organizationForm: FormGroup = new FormGroup({
    organization_id: new FormControl('', Validators.required),
    charge_frequency: new FormControl('', Validators.required),
    trial_end: new FormControl('', Validators.required),
    organization_email: new FormControl('---'),
    organization_label: new FormControl('---'),
    organization_phone: new FormControl('---'),
    organization_name_contact: new FormControl('---'),
    organization_city: new FormControl('---'),
    organization_zone: new FormControl('---'),
  });

  organizations: any = [];
  productsServices: any = []
  dataSource: any = [];
  charges: any = this.uService.charges;

  displayedColumns: any = [
    {variable: 'rowNumber', displayedName: 'N.'},
    {variable: 'product', displayedName: 'Producto'},
    {variable: 'business_unit', displayedName: 'Unidad de negocio'},
    {variable: 'price_type', displayedName: 'Tipo de precio'},
    {variable: 'trial_start', displayedName: 'Inicio periodo de prueba'},
    {variable: 'trial_end', displayedName: 'Final periodo de prueba'},
    {variable: 'trial_price', displayedName: 'Precio de prueba'},
    {variable: 'price', displayedName: 'Precio'},
    {variable: 'payment_type', displayedName: 'Tipo de precio'},
    {variable: 'quantity', displayedName: 'Cantidad'},
    {variable: 'time', displayedName: 'Tiempo'},
  ];

  updateData(data: any){
    this.dataSource = [...data];
  }

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalViewTradeAgreementComponent2>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.dataSource = data;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

